import $ from 'jquery';
import { Modal } from 'bootstrap';

const header = document.querySelector('.site-header');

const setHeaderScroll = () => {
    const pos = window.pageYOffset;

    if (pos > 0 && window.matchMedia('(min-width: 1200px)').matches) {
        header.classList.add('site-header--scroll');
    } else {
        header.classList.remove('site-header--scroll');
    }
};

window.addEventListener('load', setHeaderScroll);
window.addEventListener('scroll', setHeaderScroll);
window.addEventListener('resize', setHeaderScroll);

const setHeaderItemsWidth = () => {
    let headerItemsWidth = 0;
    $('.header-nav__menu > li').each(function () {
        headerItemsWidth += $(this).outerWidth();
    });

    headerItemsWidth += $('.header-nav .custom-logo-link').outerWidth();

    $('.header-nav .sub-menu').css('width', `${headerItemsWidth}px`);
};

//window.onload = setHeaderItemsWidth;
//window.onresize = setHeaderItemsWidth;

$('.hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu-active');
});
